import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';

const RangeMarks = ({
  data,
  className,
  style,
  ...props
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.marks, className), style, ...props }, data.map((item, i) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles.mark, {
      [styles.rakeback]: item.type === "rakeback"
    }),
    key: i
  },
  item.label
)));
RangeMarks.displayName = "Range.RangeMarks";

export { RangeMarks };
//# sourceMappingURL=index.js.map
